<fieldset class="d-flex flex-column gap-1" aria-labelledby="usage-legend">
  <div class="d-flex justify-content-between align-items-center mb-0">
    <legend class="h6 fw-bold mb-0 w-auto" id="usage-legend">
      {{ content.usageTitle }}
    </legend>
    @if (!content.estimateConsumptionButtonShownBeneathFields) {
      <ng-container *ngTemplateOutlet="estimateConsumptionButton" />
    }
  </div>
  @if (controls?.doubleMeter?.value) {
    <div
      class="d-flex gap-1"
      [class.flex-column]="
        content.electricityConsumptionFieldsVerticallyStacked
      "
      wlAutomationId="electricity-consumption-fields"
    >
      @if (content.useAccessibleCalculator) {
        <div>
          <crnt-form-control>
            <crnt-text-input
              [state]="
                controls?.electricityUsageNormal?.isValid
                  ? 'enabled'
                  : 'invalid'
              "
            >
              <input
                type="text"
                inputmode="numeric"
                [id]="controls?.electricityUsageNormal?.id"
                [ngrxFormControlState]="controls?.electricityUsageNormal"
                [ngrxValueConverter]="_stringNumberConverter"
                autofocus="true"
                aria-live="polite"
                wlAutocompleteDisabled
              />
              <crnt-icon
                icon="sun"
                slot="leading"
                aria-hidden="true"
                size="base"
              ></crnt-icon>
              <div slot="trailing">{{ content.electricityUsageUnit }}</div>
            </crnt-text-input>

            <crnt-form-control-label slot="label">
              <label
                class="fw-normal"
                [for]="controls?.electricityUsageNormal?.id"
                >{{ content.electricityUsageNormalLabel }}</label
              >
            </crnt-form-control-label>

            @if (controls.electricityUsageNormal | isInvalid) {
              @if (controls.electricityUsageNormal?.errors?.requiredNumber) {
                <crnt-form-control-validation-message
                  slot="validation"
                  aria-live="polite"
                  wlAutomationId="empty-numeric-input-error"
                >
                  Vul je normaal energieverbruik in
                </crnt-form-control-validation-message>
              } @else {
                <crnt-form-control-validation-message
                  slot="validation"
                  aria-live="polite"
                  wlAutomationId="invalid-numeric-input-error"
                >
                  Controleer je normaal energieverbruik
                </crnt-form-control-validation-message>
              }
            }
          </crnt-form-control>
        </div>
        <div>
          <crnt-form-control>
            <crnt-text-input
              [state]="
                controls?.electricityUsageOffPeak?.isValid
                  ? 'enabled'
                  : 'invalid'
              "
            >
              <input
                wlAutocompleteDisabled
                type="text"
                inputmode="numeric"
                [id]="controls?.electricityUsageOffPeak?.id"
                [ngrxFormControlState]="controls?.electricityUsageOffPeak"
                [ngrxValueConverter]="_stringNumberConverter"
              />
              <crnt-icon
                icon="moon"
                slot="leading"
                aria-hidden="true"
                size="base"
              ></crnt-icon>
              <div slot="trailing">{{ content.electricityUsageUnit }}</div>
            </crnt-text-input>

            <crnt-form-control-label slot="label"
              ><label
                class="fw-normal"
                [for]="controls?.electricityUsageOffPeak?.id"
                >{{ content.electricityUsageOffPeakLabel }}</label
              ></crnt-form-control-label
            >

            @if (controls.electricityUsageOffPeak | isInvalid) {
              @if (controls.electricityUsageOffPeak?.errors?.requiredNumber) {
                <crnt-form-control-validation-message
                  slot="validation"
                  aria-live="polite"
                  wlAutomationId="empty-numeric-input-error"
                >
                  Vul je dal energieverbruik in
                </crnt-form-control-validation-message>
              } @else {
                <crnt-form-control-validation-message
                  slot="validation"
                  aria-live="polite"
                  wlAutomationId="invalid-numeric-input-error"
                >
                  Controleer je dal energieverbruik
                </crnt-form-control-validation-message>
              }
            }
          </crnt-form-control>
        </div>
      } @else {
        <div>
          <wl-input-group
            icon="sun"
            [suffix]="content.electricityUsageUnit"
            [valid]="controls?.electricityUsageNormal | isValid"
            [invalid]="controls?.electricityUsageNormal | isInvalid"
          >
            <wl-number
              wlAutocompleteDisabled
              [formsControl]="controls?.electricityUsageNormal"
              [label]="content.electricityUsageNormalLabel ?? ''"
              [placeholder]="content.electricityUsageNormalPlaceholder ?? ''"
              [locale]="'nl-NL'"
              [rendering]="rendering"
              stepName="invullen"
              fieldName="stroomverbruik jaar piek"
              [step]="0"
              class="flex-grow-1"
            />
          </wl-input-group>
          <ng-container
            *ngTemplateOutlet="
              errorMessages;
              context: {
                formControl: controls?.electricityUsageNormal,
                errorTrackingDescription: 'stroomverbruik jaar piek',
              }
            "
          />
        </div>
        <div>
          <wl-input-group
            icon="moon"
            [suffix]="content.electricityUsageUnit"
            [valid]="controls?.electricityUsageOffPeak | isValid"
            [invalid]="controls?.electricityUsageOffPeak | isInvalid"
          >
            <wl-number
              wlAutocompleteDisabled
              [formsControl]="controls?.electricityUsageOffPeak"
              [label]="content.electricityUsageOffPeakLabel ?? ''"
              [placeholder]="content.electricityUsageOffPeakPlaceholder ?? ''"
              [rendering]="rendering"
              [locale]="'nl-NL'"
              stepName="invullen"
              fieldName="stroomverbruik jaar dal"
              [step]="0"
              class="flex-grow-1"
            />
          </wl-input-group>
          <ng-container
            *ngTemplateOutlet="
              errorMessages;
              context: {
                formControl: controls?.electricityUsageOffPeak,
                errorTrackingDescription: 'stroomverbruik jaar dal',
              }
            "
          />
        </div>
      }
    </div>
  } @else {
    <div>
      @if (content.useAccessibleCalculator) {
        <crnt-form-control>
          <crnt-text-input
            [state]="
              controls?.electricityUsage?.isValid ? 'enabled' : 'invalid'
            "
          >
            <input
              wlAutocompleteDisabled
              type="text"
              inputmode="numeric"
              [id]="controls?.electricityUsage?.id"
              [ngrxFormControlState]="controls?.electricityUsage"
              [ngrxValueConverter]="_stringNumberConverter"
              wlAutomationId="electricity-consumption-field"
            />
            <crnt-icon
              icon="plug"
              slot="leading"
              aria-hidden="true"
              size="base"
            ></crnt-icon>
            <div slot="trailing">{{ content.electricityUsageUnit }}</div>
          </crnt-text-input>

          <crnt-form-control-label slot="label">
            <label class="fw-normal" [for]="controls?.electricityUsage?.id">{{
              content.electricityUsageLabel
            }}</label>
          </crnt-form-control-label>

          @if (controls.electricityUsage | isInvalid) {
            @if (controls.electricityUsage?.errors?.requiredNumber) {
              <crnt-form-control-validation-message
                slot="validation"
                aria-live="polite"
                wlAutomationId="empty-numeric-input-error"
              >
                Vul je energieverbruik in
              </crnt-form-control-validation-message>
            } @else {
              <crnt-form-control-validation-message
                slot="validation"
                aria-live="polite"
                wlAutomationId="invalid-numeric-input-error"
              >
                Controleer je energieverbruik
              </crnt-form-control-validation-message>
            }
          }
        </crnt-form-control>
      } @else {
        <wl-input-group
          icon="plug"
          [suffix]="content.electricityUsageUnit"
          [valid]="controls?.electricityUsage | isValid"
          [invalid]="controls?.electricityUsage | isInvalid"
          wlAutomationId="electricity-consumption-field"
        >
          <wl-number
            wlAutocompleteDisabled
            [formsControl]="controls?.electricityUsage"
            [label]="content.electricityUsageLabel ?? ''"
            [locale]="'nl-NL'"
            [placeholder]="content.electricityUsagePlaceholder ?? ''"
            [rendering]="rendering"
            stepName="invullen"
            fieldName="stroomverbruik jaar"
            [step]="0"
            class="flex-grow-1"
          />
        </wl-input-group>
        <ng-container
          *ngTemplateOutlet="
            errorMessages;
            context: {
              formControl: controls?.electricityUsage,
              errorTrackingDescription: 'stroomverbruik jaar',
            }
          "
        />
      }
    </div>
  }
  @if (shouldShowGasField) {
    <div wlAutomationId="gas-field">
      @if (content.useAccessibleCalculator) {
        <crnt-form-control>
          <crnt-text-input>
            <input
              wlAutocompleteDisabled
              type="text"
              inputmode="numeric"
              [id]="controls?.gasUsage?.id"
              [ngrxFormControlState]="controls?.gasUsage"
              [ngrxValueConverter]="_stringNumberConverter"
              [wlAutomationId]="controls?.gasUsage?.id"
            />
            <crnt-icon
              icon="fire-flame"
              slot="leading"
              aria-hidden="true"
              size="base"
            ></crnt-icon>
            <div slot="trailing">{{ content.gasUsageUnit }}</div>
          </crnt-text-input>
          <crnt-form-control-label slot="label">
            <label class="fw-normal" [for]="controls?.gasUsage?.id">{{
              content.gasUsageLabel
            }}</label></crnt-form-control-label
          >
          @if (controls.gasUsage | isInvalid) {
            @if (controls.gasUsage?.errors?.requiredNumber) {
              <crnt-form-control-validation-message
                slot="validation"
                aria-live="polite"
                wlAutomationId="empty-numeric-input-error"
              >
                Vul je gasverbruik in
              </crnt-form-control-validation-message>
            } @else {
              <crnt-form-control-validation-message
                slot="validation"
                aria-live="polite"
                wlAutomationId="invalid-numeric-input-error"
              >
                Controleer je gasverbruik
              </crnt-form-control-validation-message>
            }
          }
        </crnt-form-control>
      } @else {
        <wl-input-group
          icon="fire-flame"
          [suffix]="content.gasUsageUnit"
          [valid]="controls?.gasUsage | isValid"
          [invalid]="controls?.gasUsage | isInvalid"
        >
          <wl-number
            wlAutocompleteDisabled
            [formsControl]="controls?.gasUsage"
            [label]="content.gasUsageLabel ?? ''"
            [placeholder]="content.gasUsagePlaceholder ?? ''"
            [rendering]="rendering"
            [locale]="'nl-NL'"
            stepName="invullen"
            fieldName="gasverbruik jaar"
            [step]="0"
            class="flex-grow-1"
          />
        </wl-input-group>
        <ng-container
          *ngTemplateOutlet="
            errorMessages;
            context: {
              formControl: controls?.gasUsage,
              errorTrackingDescription: 'gasverbruik jaar',
            }
          "
        />
      }
    </div>
  }
  @if (content.estimateConsumptionButtonShownBeneathFields) {
    <ng-container *ngTemplateOutlet="estimateConsumptionButton" />
  }
</fieldset>

<ng-template
  #errorMessages
  let-control="formControl"
  let-description="errorTrackingDescription"
>
  @if (control | isInvalid) {
    @if (control?.errors?.requiredNumber) {
      <wl-input-error
        [label]="content.requiredError"
        [rendering]="rendering"
        [messageDescription]="description"
        stepName="invullen"
        wlAutomationId="empty-numeric-input-error"
      />
    }
    @if (control?.errors?.isInt) {
      <wl-input-error
        [label]="content.invalidNumberError"
        [rendering]="rendering"
        [messageDescription]="description"
        stepName="invullen"
        wlAutomationId="input-is-not-integer-error"
      />
    }
    @if (control?.errors?.noInputsFilled) {
      <wl-input-error
        [label]="content.noInputsFilledError"
        [rendering]="rendering"
        [messageDescription]="description"
        stepName="invullen"
        wlAutomationId="empty-form-error"
      />
    }
  }
</ng-template>

<ng-template #estimateConsumptionButton>
  @if (content.useAccessibleCalculator) {
    <crnt-button
      variant="tertiary"
      (click)="calculateOpenModal.emit(!shouldShowGasField)"
      wlAutomationId="calculate-form-usage.openQuestionnaire"
      [ngClass]="{
        'align-self-start py-2':
          content.estimateConsumptionButtonShownBeneathFields,
      }"
      >{{ content.estimateUsageLinkText }}</crnt-button
    >
  } @else {
    @if (content.estimateConsumptionButtonShownBeneathFields) {
      <button
        (click)="calculateOpenModal.emit(!shouldShowGasField)"
        type="button"
        class="btn btn-outline-primary mt-2"
        wlAutomationId="calculate-form-usage.openQuestionnaire"
      >
        {{ content.estimateUsageLinkText }}
      </button>
    } @else {
      <button
        (click)="calculateOpenModal.emit(!shouldShowGasField)"
        type="button"
        class="btn btn-link p-0"
        wlAutomationId="calculate-form-usage.openQuestionnaire"
      >
        {{ content.estimateUsageLinkText }}
      </button>
    }
  }
</ng-template>
